import { useCallback, useEffect, useState } from 'react';
import { Button, CircularProgress, Grid } from '@mui/material';
import dayjs from 'dayjs';
import { SelectDate, SelectDateEventType } from '@shared/components/SelectDate';
import { LoaderWrapper } from '@styles/StyledDiv';

interface IOutOfSyncFormProps {
  handleSearchBtn: (startDate: string | null, endDate: string | null) => void;
  isLoading: boolean;
}

const OutOfSyncForm = ({ handleSearchBtn, isLoading }: IOutOfSyncFormProps) => {
  const [startDate, setStartDate] = useState<string | null>(dayjs().subtract(30, 'day').format());
  const [endDate, setEndDate] = useState<string | null>(dayjs().format());

  useEffect(() => {
    handleSearchBtn(startDate, endDate);
  }, []);

  const handleStartDate = useCallback((event: SelectDateEventType) => {
    setStartDate(event.target.value);
  }, []);

  const handleEndDate = useCallback((event: SelectDateEventType) => {
    setEndDate(event.target.value);
  }, []);

  return (
    <Grid container spacing={2}>
      <Grid item md={3}>
        <SelectDate label="Start Date" value={startDate} onChange={handleStartDate} />
      </Grid>
      <Grid item md={3}>
        <SelectDate label="End Date" value={endDate} onChange={handleEndDate} />
      </Grid>
      <Grid item md={3}>
        <Button size="large" variant="contained" disabled={isLoading} onClick={() => handleSearchBtn(startDate, endDate)}>
          {!isLoading && 'Search'}
          {isLoading && (
            <LoaderWrapper>
              <CircularProgress color="primary" size={25} />
            </LoaderWrapper>
          )}
        </Button>
      </Grid>
    </Grid>
  );
};

export default OutOfSyncForm;
